import { type ReactNode } from "react"

interface QuickSpecCardProps {
  /** Lucide icon or SVG element */
  icon: ReactNode
  /** Label text (e.g. "Width", "Capacity") */
  label: string
  /** Value text (e.g. "42 Inches", "24.2 Cu. Ft.") */
  value: string
  /** Additional classes on the wrapper */
  className?: string
}

export function QuickSpecCard({ icon, label, value, className = "" }: QuickSpecCardProps) {
  return (
    <div className={`p-2.5 bg-gray-50 rounded-lg flex items-center gap-2.5 ${className}`}>
      <div className="w-8 h-8 rounded-lg bg-[#0469f0]/10 flex items-center justify-center text-[#0469f0]">
        {icon}
      </div>
      <div>
        <div className="text-[10px] text-gray-500 uppercase font-bold">{label}</div>
        <div className="text-sm font-bold text-gray-900">{value}</div>
      </div>
    </div>
  )
}
